export default function datepickerAddon($sce) {
  'ngInject';

  return {
    restrict: 'E',
    require: '^?datepickerWithAddon',
    scope: true,
    link($scope, $element, $attrs, $ctrl) {
      if ($scope.datepickerOptions && 'datepickerAddon' in $scope.datepickerOptions) {
        $scope.datepickerAddonShown = true;
        $scope.datepickerAddon = $scope.datepickerOptions.datepickerAddon;
      } else if ($ctrl) {
        $scope.datepickerAddonShown = true;
        $scope.datepickerAddon = $ctrl;
      }

      if ($scope.datepickerAddon) {
        if (
          $scope.datepickerAddon.template &&
          typeof $scope.datepickerAddon.template === 'string'
        ) {
          $scope.datepickerAddon.template = $sce.trustAsHtml($scope.datepickerAddon.template);
        }
      }
    },
  };
}
